import { applyMiddleware, createStore } from "redux";
import rootReducer from "./reducers/globalStore";
import createSagaMiddleware from 'redux-saga';
import rootsaga from './sagas/rootsaga';
import "regenerator-runtime/runtime";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createLogger } from 'redux-logger';

const logger = createLogger({
    // ...options
    collapsed: true
});

const persistConfig = {
    key: 'authType',
    storage: storage,
    whitelist: ['recentJobs', 'selectedJobId', 'topCategories',
        'userSession', 'userProfile', 'skills', 'jobCategories', 'appStatusTypes'], // which reducer want to store,
    blackList: [],
};

const pReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

const store = createStore(pReducer, applyMiddleware(logger, sagaMiddleware));

sagaMiddleware.run(rootsaga);

// export default store;
const persistor = persistStore(store);
export { persistor, store };